import { isEmpty } from "lodash";
import { toNFTId } from "../../nft";
import { compareText, toJSON } from "../../utils";
export class NFTConstraintCollectionConfig {
    constructor(params) {
        this.network = params.network;
        this.collectionId = params.collectionId.toLowerCase();
        this.id = toNFTId([this.network, this.collectionId]);
        if (params.attributes && !isEmpty(params.attributes))
            this.attributes = params.attributes.filter((attribute) => attribute.traitType && attribute.values);
    }
    validateNFT(nft) {
        if (nft.network != this.network)
            return false;
        if (nft.collectionId != this.collectionId)
            return false;
        if (this.attributes && this.attributes.length > 0) {
            let valid = false;
            for (const attribute of this.attributes) {
                if (!attribute.traitType || isEmpty(attribute.values))
                    continue;
                // OR relation across traitType
                const _nftTrait = nft.attributes.find((a) => compareText(a.traitType, attribute.traitType));
                if (_nftTrait &&
                    attribute.values
                        .map((v) => v.trim().toLowerCase())
                        .includes(String(_nftTrait.value).trim().toLowerCase()))
                    return true;
            }
            return valid;
        }
        return true;
    }
}
export class NFTConstraint {
    constructor(params) {
        this.collections =
            (params === null || params === void 0 ? void 0 : params.collections) && params.collections.length > 0
                ? params.collections
                    .filter((c) => c && c.network && c.collectionId)
                    .map((c) => new NFTConstraintCollectionConfig(c))
                : [];
    }
    get json() {
        return toJSON(this);
    }
}
